import { S } from "../theme";

function ReadOnlyOverlay({ setActive }) {
  return (
    <div style={{
      background: S.white,
      border: "1px solid " + S.accent2 + "44",
      borderRadius: 16,
      padding: "32px 28px",
      textAlign: "center",
      margin: "24px auto",
      maxWidth: 480,
    }}>
      <div style={{ fontSize: "1.6rem", marginBottom: 12 }}>🔒</div>
      <h3 style={{ fontFamily: "'Fraunces', serif", fontWeight: 500, fontSize: "1.2rem", color: S.ink, marginBottom: 8 }}>
        Subscribe to unlock
      </h3>
      <p style={{ fontSize: "0.85rem", color: S.muted, lineHeight: 1.6, marginBottom: 20, fontFamily: "'Fraunces', serif", fontStyle: "italic" }}>
        Your trial has ended. Pick a plan to keep tracking, logging, and using AI guidance.
      </p>
      <button onClick={() => setActive("pricing")} style={{
        background: S.accent, color: "#fff", border: "none", borderRadius: 100,
        padding: "12px 28px", fontFamily: "'Inter', sans-serif", fontWeight: 600,
        fontSize: "0.9rem", cursor: "pointer", boxShadow: "0 4px 16px rgba(126,171,142,0.25)",
      }}>
        View plans
      </button>
    </div>
  );
}

// ─── LANDING PAGE ────────────────────────────────────────────

export { ReadOnlyOverlay };
